import DropdownButton from "../../../../components/button/dropdown-button.jsx";
import {FaChevronRight, FaEllipsisH} from "react-icons/fa";

function limitText(text, maxLength = 20) {
    if (!text) return "";

    return text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text;
}

function BreadcrumbButton({ children, onClick }) {
    const label = typeof children === "string"
        ? children
        : "";

    return (
        <button
            type="button"
            onClick={onClick}
            title={label}
            className="pl-2 text-[18px]! font-semibold hover:underline cursor-pointer whitespace-nowrap shrink-0"
        >
            {limitText(label, 25)}
        </button>
    )
}

export default function LibraryBreadcrumb({ breadcrumbs = [], onRootClick, onFolderClick, maxVisibleItems = 3 }) {
    const shouldCollapseBreadcrumbs = breadcrumbs.length > maxVisibleItems;

    const hiddenBreadcrumbs = shouldCollapseBreadcrumbs
        ? breadcrumbs.slice(0, -maxVisibleItems)
        : [];

    const visibleBreadcrumbs = shouldCollapseBreadcrumbs
        ? breadcrumbs.slice(-maxVisibleItems)
        : breadcrumbs;

    return (
        <div className="flex min-w-0 items-center gap-2 whitespace-nowrap">
            {!shouldCollapseBreadcrumbs && (
                <BreadcrumbButton onClick={onRootClick}>
                    Minha biblioteca
                </BreadcrumbButton>
            )}

            {shouldCollapseBreadcrumbs && (
                <DropdownButton
                    align="left"
                    buttonContent={<FaEllipsisH />}
                    buttonClassName="
                        flex h-8 w-8 shrink-0 items-center justify-center
                        rounded-lg text-[#676a6c] cursor-pointer
                        hover:bg-[#E5E7EB]
                        focus:outline-none focus:ring-0
                        transition-colors duration-200 ease-in-out
                    "
                    menuClassName="min-w-48"
                    items={[
                        {
                            key: "root",
                            label: "Minha biblioteca",
                            onClick: onRootClick,
                        },
                        ...hiddenBreadcrumbs.map((folder, index) => ({
                            key: folder.id,
                            label: folder.name,
                            onClick: () => onFolderClick(index),
                        })),
                    ]}
                />
            )}

            {visibleBreadcrumbs.map((folder, index) => {
                const realIndex = hiddenBreadcrumbs.length + index;
                return (
                    <div key={`${folder.id}-${realIndex}`} className="flex shrink-0 whitespace-nowrap items-center">
                        <FaChevronRight />
                        <BreadcrumbButton onClick={() => onFolderClick(realIndex)}>
                            {folder.name}
                        </BreadcrumbButton>
                    </div>
                )
            })}
        </div>
    )
}